/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'

export const countryDataSchema = z.object({
	id: z.string(),
	name: z.string(),
})

export type CountryDataSchema = z.infer<typeof countryDataSchema>
